<template>
  <div class="course-page">
    <headers :title="title"
             :returnShow="false"
             @toGet="goSearh">
      <template slot="right-sum">
        <img class="search"
             src="@/assets/images/search.png"
             alt />
      </template>
    </headers>
    <div class="course-fitler">
      <van-tabs @click="onTabChange"
                title-active-color="#333333"
                title-inactive-color="#BEBEBE"
                line-width="8vw"
                line-height="0.53333vw"
                :ellipsis="false"
                :border="false"
                class="filter1">
        <van-tab v-for="(item,index) in classifyList"
                 :title="item.title"
                 :key="index">
        </van-tab>
      </van-tabs>
      <div class="filter2"
           @click="onShowFilter">
        <img src="@/assets/images/filter.png"
             alt="筛选">
        筛选
      </div>
      <van-popup v-model="showFilter"
                 position="right">
        <div class="popup-content">
          <section class="box">
            <div>
              <div class="title">
                <span>课程类型</span>
              </div>
              <div class="content">
                <div class="btn"
                     :class="course_type == item ? 'selected':''"
                     v-for="(item,index) in course_types"
                     :key="index"
                     @click="onBtn('course_type',item)">{{getCourse(item)}}</div>
              </div>
            </div>
            <div>
              <div class="title">
                <span>价格</span>
              </div>
              <div class="content">
                <div class="btn"
                     :class="price == item.value ? 'selected':''"
                     v-for="(item,index) in price_attr"
                     :key="index"
                     @click="onBtn('price',item)">{{item.name}}</div>
              </div>
            </div>
            <div v-for="(item,index) in attrclassify"
                 :key="index">
              <div class="title">
                <span>{{item.name}}</span>
                <span class="arrow"
                      @click="onArrow">
                  <i :class="{'el-icon-arrow-down': !isExpandSecondClassify, 'el-icon-arrow-up': isExpandSecondClassify}"></i>
                </span>
              </div>
              <div class="content">
                <div class="btn"
                     :class="attr_val_id['attr'+index] == it.id ? 'selected':''"
                     v-for="(it,i) in item.child"
                     :key="i"
                     @click="onBtn(it.id,'attr'+index)">{{it.name}}</div>
              </div>
            </div>
          </section>
        </div>

        <div class="popup-btn">
          <div class="btn"
               @click="onReset">重置</div>
          <div class="btn"
               @click="onOk">完成</div>
        </div>
      </van-popup>
      <!-- <van-dropdown-menu :active-color="$theme_color">
        <van-dropdown-item title="分类" ref="kinds">
          <div class="parent-box">
            <div class="tm-kind" v-for="(item,index) in attrclassify" :key="item.id">
              <p>{{item.name}}</p>
              <div class="tmk-item">
                <span
                  :class="attr_val_id['attr'+index] == it.id ? 'active':''"
                  v-for="it in item.child"
                  :key="it.id"
                  @click="selectId(it.id,'attr'+index)"
                >{{it.name}}</span>
              </div>
            </div>
            <div class="seach-btn">
              <van-button @click="reset">重置</van-button>
              <van-button @click="searchFor('kinds')">确定</van-button>
            </div>
          </div>
        </van-dropdown-item>
        <van-dropdown-item title="排序" ref="sort">
          <ul class="course-sort">
            <li
              :class="order_by == item.value ? 'active':''"
              v-for="item in option"
              :key="item.value"
              @click="selectType('sort',item.value)"
            >{{item.text}}</li>
          </ul>
        </van-dropdown-item>
        <van-dropdown-item title="筛选" ref="filter">
          <div class="filter-box">
            <div class="tm-kind">
              <div class="tmk-item">
                <span :class="course_type == 0 ? 'active':''" @click="selectType('filter',0)">全部</span>
                <span
                  :class="course_type == item ? 'active':''"
                  v-for="item in course_types"
                  :key="item"
                  @click="selectType('filter',item)"
                >{{getCourse(item)}}</span>
                <span
                  v-if="vipCourseCount"
                  :class="course_type == 11 ? 'active':''"
                  @click="selectType('filter',11)"
                >会员课</span>
              </div>
            </div>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu> -->
    </div>
    <Empty :empty_type="emptyType"
           class="emptyData"
           v-if="courses.length == 0"></Empty>
    <List ref="list"
          :showText="courses.length > 0"
          url="/api/app/courseBasis"
          method="get"
          :params="params"
          :on-getdata="onGetdata">
      <course-item slot="item"
                   :course="courses"></course-item>
    </List>
  </div>
</template>

<script>
import { CourseType } from "@/util/enums";
import headers from "@/components/Header";
import courseItem from "@/components/CourseItem";
import List from "@/components/List";
import Empty from "@/components/Empty";
export default {
  name: "Course",
  components: {
    headers,
    courseItem,
    List,
    Empty
  },
  data () {
    return {
      title: {
        name: "课程列表"
      },
      option: [
        { text: "综合排序", value: 0 },
        { text: "最新", value: 1 },
        { text: "最热", value: 2 },
        { text: "价格从低到高", value: 3 },
        { text: "价格从高到低", value: 4 }
      ],
      attrclassify: [],
      attr_val_id: {},
      order_by: "",
      course_types: [],
      price_attr: [],
      price: '',
      course_type: 0,
      courses: [],
      params: {},
      classifyList: [],
      vipCourseCount: "",
      showFilter: false,
      initCompleted: false,
      isExpandSecondClassify: false, // 是否展开了二级分类
      emptyType: {
        name: "暂无数据"
      },
    };
  },
  created () {
    this.params.classify_id = this.$store.state.personInfo.classify_id || localStorage.classify_id;
    this.getClassify();
    this.getClassifyList();
  },
  methods: {
    onLoad () {
      this.page++;
      this.getCourses();
    },
    goSearh () {
      this.$router.push({
        name: "Search"
      });
    },
    getClassifyList () {
      let param = { classify_id: this.$store.state.personInfo.classify_id || localStorage.classify_id };
      this.$pub.getClassify(param).then(res => {
        if (res.length > 0) {
          res.unshift({ id: '', title: '全部' });
          this.classifyList = res;
        }
      })
    },
    reset () {
      for (let i in this.attr_val_id) {
        this.attr_val_id[i] = 0;
      }
      this.searchFor("kinds");
    },
    searchFor (name) {
      // this.$refs[name].toggle();
      this.params = {
        course_type: this.course_type != 11 ? this.course_type : 0,
        price: this.price,
        classify_id: this.params.classify_id,
        attr_val_id: this.$pub.objToStr(this.attr_val_id, ","),
        is_vip: this.course_type == 11 ? 1 : 0
      };
      this.$refs.list.reset();
    },
    selectType (name, val) {
      if (name == "filter") {
        this.course_type = val;
      } else {
        this.order_by = val;
      }
      this.searchFor(name);
    },
    selectId (id, attr) {
      this.$set(this.attr_val_id, attr, id);
    },
    getClassify () {
      this.$http.get(`/api/app/courseClassify`).then(res => {
        this.attrclassify = res.attrclassify;
        let attr_val_id = {};
        res.attrclassify.forEach((item, index) => {
          attr_val_id["attr" + index] = 0;
          if (item.child.length > 0) {
            // item.child.unshift({ id: 0, name: '全部' })
          }
        });
        this.course_types = res.courseTypes;
        this.price_attr = res.price;
        this.vipCourseCount = res.vipCourseCount;
      });
    },
    onGetdata (data) {
      this.courses = data;
    },
    getCourse (val) {
      return CourseType.getValue(val);
    },
    onTabChange (index) {
      if (this.classifyList[index].id) {
        this.params.classify_id = this.classifyList[index].id;
      } else {
        this.params.classify_id = this.$store.state.personInfo.classify_id || localStorage.classify_id;
      }
      this.$refs.list.reset();
    },
    onShowFilter () {
      this.showFilter = true;
    },
    onArrow () {

    },
    onBtn (flag, item) {
      if (flag == 'course_type') {
        this.course_type = item;
      } else if (flag == 'price') {
        this.price = item.value;
      } else {//动态属性
        this.$set(this.attr_val_id, item, flag);
      }
    },
    onReset () {
      this.price = '';
      this.course_type = 0;
      for (let i in this.attr_val_id) {
        this.attr_val_id[i] = 0;
      }
    },
    onOk () {
      this.searchFor();
      this.showFilter = false;
    },

  },
  watch: {
    $route (val) {
      if (val.name == "Course") {
        this.$refs.list.reset();
        this.getClassifyList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.course-page {
  min-height: 100vh;
  background: #f0f2f5;
  padding-bottom: 100px;
  .search {
    width: 38px;
    height: 40px;
    margin-top: 20px;
  }
  .parent-box {
    padding-left: 30px;
    padding-bottom: 20px;
    .seach-btn {
      padding: 30px 0px;
      display: flex;
      justify-content: space-between;
      button {
        width: 340px;
        height: 66px;
        background: rgba(255, 255, 255, 1);
        border-radius: 8px;
        border: 2px solid rgba(217, 217, 217, 1);
        font-size: 26px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        margin-right: 20px;
        &:last-child {
          color: #fff;
          background: $theme_color;
          border: 0;
        }
      }
    }
  }
  .filter-box {
    padding-top: 40px;
    padding-left: 30px;
  }
  .tm-kind {
    padding-bottom: 20px;
    border-bottom: 1px solid #f1f1f1;
    p {
      padding: 32px 0 20px;
      font-size: 24px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
    }
    .tmk-item {
      span {
        margin: 0 46px 14px 0;
        display: inline-block;
        width: 138px;
        height: 66px;
        background: rgba(245, 245, 245, 1);
        border-radius: 6px;
        font-size: 26px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #646464;
        text-align: center;
        line-height: 66px;
        overflow: hidden;
        &:nth-child(4n + 0) {
          margin-right: 0;
        }
      }
      span.active {
        color: $theme_color;
        background: #ebeefe;
      }
    }
  }
  .course-fitler {
    padding-top: 15px;
    display: flex;
    background-color: #fff;
    border-top: 1px solid #f6f6f6;
    height: 100px;
    line-height: 100px;
    /deep/ {
      .van-overlay {
        z-index: 10000 !important;
      }
    }
  }
  .filter1 {
    flex: 5;
    width: 82%;
    /deep/ {
      .van-tabs__wrap {
        border-bottom: none;
      }
      .van-tab {
        font-size: 30px;
        color: #bebebe;
        font-weight: 500;
        margin: 0 20px;
      }
    }
  }
  .filter2 {
    flex: 1;
    font-size: 30px;
    line-height: 100px;
    margin-right: 5px;
    margin-left: 10px;
    margin-top: -5px;
    color: #bebebe;
    img {
      width: 34px;
      vertical-align: middle;
    }
  }

  .van-popup {
    z-index: 999999 !important;
    height: 100%;
    width: 629px;

    .popup-content {
      background-color: #fff;
      position: absolute;
      top: 0;
      bottom: 100px;
      overflow: scroll;
      width: 100%;

      .box {
        margin-left: 36px;
        margin-right: 36px;
        margin-top: 57px;
        padding: 0;
        font-size: 24px;
        .title {
          font-weight: bold;
          height: 26px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .arrow {
            display: inline-block;
            width: 80px;
            height: 50px;
            margin-right: 5px;
            line-height: 50px;
            text-align: right;
          }
        }
        .content {
          font-size: 25px;
          margin-top: 10px;
          margin-bottom: 62px;
          display: flex;
          justify-content: flex-start;
          flex-flow: wrap row;
          align-content: stretch;
          .btn {
            width: 170px;
            height: 72px;
            border-radius: 4px;
            margin-top: 10px;
            box-sizing: border-box;
            background-color: #f5f5f5;
            color: #666666;
            font-size: 24px;
            // 文字溢出
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            line-height: 72px;
            &:nth-child(3n-1) {
              margin-left: 20px;
              margin-right: 20px;
            }
          }
          .btn.selected {
            background-color: $theme_color;
            color: #fff;
          }
        }
      }

      .limit-height {
        height: 180px;
        overflow: hidden;
      }
    }

    .popup-btn {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 90px;
      display: flex;
      box-shadow: 0px 0px 7px 0px rgba(2, 108, 204, 0.06);
      .btn {
        width: 50%;
        // height: 100%;
        font-size: 30px;
        // border: 1px solid #f8f8f8;
        text-align: center;
        line-height: 90px;
        color: #333;
        background-color: #fff;
      }

      .btn:nth-of-type(2) {
        background-color: $theme_color;
        border-color: $theme_color;
        color: #fff;
      }
    }
  }
}
</style>
